import React, { useEffect, useState, useCallback } from "react";
import { Col, FormGroup, Row, Input, Label } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { Gogovernorates } from "Enums/fixedData";
import CitiesService from "services/Admin/CitiesService";
import MyMap from "components/Common/google-map/MyMap";
import Language from "Enums/Language";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AreaService from "services/Website/AreaServic";

const StepTwo = ({
	updateStateHandler,
	goBackHandler,
	locationData,
	setModal,
	inputLang,
}) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const [cityOptions, setCityOptions] = useState([]);
	const [showMap, setShowMap] = useState(false);
	const [areOptions, setAreaOptions] = useState([]);
	const [formData, setFormData] = useState({
		selectedCity: "",
		governorate: null,
		street_address: {
			ar: "",
			en: "",
			ru: "",
			zh: "",
		},
		area: "",
		lat: "",
		lang: "",
	});

	useEffect(() => {
		setFormData(locationData);
		setShowMap(locationData.showMap);
	}, []);

	useEffect(() => {
		setAreaDropDownOptions(formData.selectedCity?.value);
	}, [formData.selectedCity]);

	const submitFormHandler = () => {
		if (!formData.selectedCity) {
			toast.error(`${t("City is required")}`);
			return;
		} else if (!formData.governorate) {
			toast.error(`${t("Governorate is required")}`);
			return;
		} else if (validateAddress()) {
			return;
		} else if (validateArea()) {
			return;
		} else {
			if (!showMap) {
				updateStateHandler({ ...formData, lat: null, lang: null, showMap });
				return;
			}
			updateStateHandler({ ...formData, showMap });
		}
	};

	const validateArea = () => {
		if (inputLang == "en" && !validate(formData.street_address.en)) {
			toast.error(`${t("Address (en) format invalid")}`);
			return true;
		} else if (
			inputLang == "ar" &&
			!validateArabic(formData.street_address.ar)
		) {
			toast.error(`${t("Address (ar) format invalid")}`);
			return true;
		}

		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.address_ru)) {
		//     toast.error(`${t("Address (ru) format invalid")}`)
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.address_zh)) {
		//     toast.error(`${t("Address (zh) format invalid")}`)
		//     return true
		// } else {
		//     return false
		// }
	};
	const validateAddress = () => {
		if (!formData.area) {
			toast.error(`${t("Location are Required")}`);
			return true;
		}
		// else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.area_ru)) {
		//     toast.error(`${t("Area (ru) format invalid")}`)
		//     return true
		// } else if (/^[^a-zA-Z-ء-ى]+$/.test(formData.area_zh)) {
		//     toast.error(`${t("Area (zh) format invalid")}`)
		//     return true
		// } else {
		//     return false
		// }
	};
	const updateLocationPositions = (lat, lang) => {
		setFormData({ ...formData, lat, lang });
	};
	const handleFieldChange = (e) => {
		setFormData({
			...formData,
			street_address: {
				...formData.street_address,
				[e.target.name]: e.target.value,
			},
		});
	};
	useEffect(() => {
		new CitiesService().getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					...item.name,
					label: item.name[`${AuthData.lang}`]
						? item.name[`${AuthData.lang}`]
						: item.name.en,
					value: item.id,
				};
			});
			setCityOptions([...newOptions]);
		});
	}, []);
	const getOptions = useCallback(
		(lang, list) => {
			return list.map((item) => {
				return {
					...item,
					label: item[`${lang}`],
				};
			});
		},
		[AuthData.lang]
	);
	const governorateSelect = getOptions(AuthData.lang, Gogovernorates);

	const setAreaDropDownOptions = (cityId) => {
		new AreaService().getDropDown(cityId).then((res) => {
			const newOptions = res.data?.map((item) => {
				return {
					...item.name,
					label: item.name.en,
					value: item.id,
				};
			});
			setAreaOptions([...newOptions]);
		});
	};

	return (
		<AvForm onValidSubmit={(e, v) => submitFormHandler()} className="step-one">
			<p className="subtitle">{t("UPLOAD THE CONTRACT OF YOUR PROPERTY")}</p>

			<Row>
				{Language.LIST.map((lan, index) => {
					if (lan.name === inputLang) {
						return (
							<Col md={8} key={index} className="mb-3">
								<AvField
									errorMessage={t("this field is required")}
									className="style-input"
									name={lan.name}
									label={
										lan.name !== "zh"
											? t(`address ${lan.name}`)
											: "Address (Chinese)"
									}
									bsSize="lg"
									value={formData.street_address[lan.name]}
									onChange={(e) => {
										setFormData({
											...formData,
											street_address: {
												...formData.street_address,
												[e.target.name]: e.target.value,
											},
										});
									}}
									required
									placeholder={
										lan.name === "en"
											? "English"
											: lan.name === "ar"
											? " العربية"
											: lan.name === "zh"
											? "中文"
											: "Русский"
									}
								/>
							</Col>
						);
					}
				})}
				<Col md={4}></Col>
				<Col md={4}>
					<label>{t("Governorate")}</label>
					{/* <Select
                        placeholder={t("select")}
                        options={governorateSelect}
                        className='mb-3'
                        required
                        onChange={(data) => {
                            setFormData({ ...formData, governorate: data[AuthData.lang] });
                        }}
                        value={formData.governorate && governorateSelect[governorateSelect.findIndex(item=>item.label==formData.governorate.label)]}
                        //value={formData.governorate ? governorateSelect[governorateSelect.findIndex(item=>item[AuthData.lang]==formData.governorate)] : null}
                    /> */}
					<Select
						placeholder="Select"
						options={governorateSelect}
						className="mb-3"
						onChange={(data) => {
							setFormData({ ...formData, governorate: data });
						}}
						value={formData.governorate}
					/>
				</Col>
				<Col md={4}>
					<label>{t("City")}</label>
					<Select
						placeholder={t("select")}
						options={cityOptions}
						required
						className="mb-3"
						onChange={(data) => {
							setFormData({ ...formData, selectedCity: data, area: "" });
							setAreaDropDownOptions(data.value);
						}}
						value={formData.selectedCity}
					/>
				</Col>
				<Col md={4}>
					<label>Location</label>
					<Select
						placeholder="Select"
						options={areOptions}
						name="area_id"
						className="mb-3"
						onChange={(data) => {
							setFormData({ ...formData, area: data });
						}}
						value={formData.area}
					/>
				</Col>
			</Row>
			<Row className="mb-3 mx-1">
				<FormGroup check className="mt-3 mb-4">
					<Input
						id="exampleCheck"
						name="check"
						type="checkbox"
						checked={showMap}
						onChange={(e) => {
							setShowMap(e.target.checked);
							//updateLocationPositions('','')
						}}
					/>
					<Label check for="exampleCheck" style={{ fontSize: "14px" }}>
						Display Map in Resale
					</Label>
				</FormGroup>
				<MyMap
					updateLocationPositions={updateLocationPositions}
					lat={!!formData.lat ? formData.lat : 30}
					lng={!!formData.lang ? formData.lang : 31}
					draggable={showMap}
					onMouseOut={showMap}
					style={{ border: "1px solid" }}
				/>
			</Row>

			<Row className="my-4">
				<Col md={9}>
					<button
						type="button"
						style={{ borderRadius: "5px", width: "15%" }}
						className="btn btn-light btnHeight cancel text-center"
						onClick={() => setModal(true)}>
						{t("Cancel")}
					</button>
				</Col>
				<Col md={3} className="d-flex justify-content-between">
					<button
						type="button"
						onClick={() => {
							if (!showMap) {
								updateStateHandler({
									...formData,
									lat: null,
									lang: null,
									showMap,
								});
							} else {
								updateStateHandler({ ...formData, showMap });
							}

							goBackHandler();
						}}
						className="btn btn-light btnHeight back text-center"
						style={{ borderRadius: "5px", width: "45%" }}>
						{t("Back")}
					</button>
					<button
						type="submit"
						style={{
							borderRadius: "5px",
							width: "45%",
							borderColor: "var(--primary-color)",
							background: "var(--primary-color)",
						}}
						className="btn btn-success next btnHeight text-center">
						{t("Next")}
					</button>
				</Col>
			</Row>
		</AvForm>
	);
};

let validate = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (
			(str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) ||
			(str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)
		) {
			count += 1;
		}
	}

	return count >= 2 ? true : false;
};
let validateArabic = (str) => {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (str.charCodeAt(i) >= 1569 && str.charCodeAt(i) <= 1610) {
			count += 1;
		}
	}

	return count >= 2 ? true : false;
};
export default StepTwo;
